import { LoginPreferences } from '@services/session';

export interface ICardState {
  submitAttempt: boolean;
  headerBackground: string;
}

export enum CardIds {
  FleetUser = 'fleetUserForm',
  DataUsage = 'dataUsageForm',
  DataRetention = 'dataRetentionForm',
}

export interface ILoginPreference {
  value: LoginPreferences;
  label: string;
}

export interface IDataRetentionDropdownOption {
  value: DATA_RENTENTION_DURATION;
  label: typeof DATA_RETENTION_DURATION_OPTION_LABEL[keyof typeof DATA_RETENTION_DURATION_OPTION_LABEL];
}

export interface IDataRetentionConfig {
  type: DATA_RETENTION_TYPE;
  title: string;
  retentionDataInfo: string;
  formControlName: string;
  prevDurationValueKey: string;
  dropdownOptions: IDataRetentionDropdownOption[];
}

export const DATA_RETENTION_DURATION_TYPE_MAPPER: Record<string, string> = {
  D: 'day',
  W: 'week',
  M: 'month',
  Y: 'year',
};

export enum DATA_RETENTION_TYPE {
  SAFETY = 'SAFETY',
  COMPLIANCE = 'COMPLIANCE',
  MESSAGING = 'MESSAGING',
  LOCATION = 'LOCATION',
  MAINTENANCE = 'MAINTENANCE',
}

export enum DATA_RENTENTION_DURATION {
  DEFAULT = 'DEFAULT',
  ONE_YEAR = '1Y',
  SIX_MONTHS = '6M',
  ONE_MONTH = '1M',
  THREE_MONTH = '3M',
  TWO_WEEKS = '2W',
}

export const DATA_RETENTION_DURATION_OPTION_LABEL: Record<DATA_RENTENTION_DURATION, string> = {
  [DATA_RENTENTION_DURATION.DEFAULT]: $localize`Store data indefinitely`,
  [DATA_RENTENTION_DURATION.ONE_YEAR]: $localize`Store data for 1 year`,
  [DATA_RENTENTION_DURATION.SIX_MONTHS]: $localize`Store data for 6 months`,
  [DATA_RENTENTION_DURATION.ONE_MONTH]: $localize`Store data for 1 month`,
  [DATA_RENTENTION_DURATION.TWO_WEEKS]: $localize`Store data for 2 weeks`,
  [DATA_RENTENTION_DURATION.THREE_MONTH]: $localize`Store data for 3 months`,
};

/**
 * Key used to store the prev selected value in Data Retention Settings dropdown.
 */
export const DATA_RETENTION_PREV_DURATION_VALUE_KEY: Record<DATA_RETENTION_TYPE, string> = {
  [DATA_RETENTION_TYPE.SAFETY]: 'safetyPrevDurationValueKey',
  [DATA_RETENTION_TYPE.COMPLIANCE]: 'compliancePrevDurationValueKey',
  [DATA_RETENTION_TYPE.MESSAGING]: 'messagesPrevDurationValueKey',
  [DATA_RETENTION_TYPE.LOCATION]: 'locationsPrevDurationValueKey',
  [DATA_RETENTION_TYPE.MAINTENANCE]: 'maintenancePrevDurationValueKey',
};

export type LoginPreferencesType = { [key in LoginPreferences]: string };
export const loginPreferenceMap: LoginPreferencesType = {
  [LoginPreferences.BASIC]: $localize`Email and password`,
  [LoginPreferences.SSO]: $localize`SSO (Single sign-on)`,
  [LoginPreferences.HYBRID]: $localize`SSO (single sign-on) or Email/Username`,
};